import * as React from "react";

import {useSelector} from "react-redux";
import {State} from "../../reducer";
import {ParamsMarqueCollection} from "../../types";
import {Grid} from "@mui/material";
import TextField from "@mui/material/TextField";
import {resetMarqueEditorialeParameter, updateMarqueEditorialeParameter} from "../../action/parametrageAction";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useAppDispatch } from "../../store";


interface Props {
    marqueId: string,
    collectionId?: string,
    label: string,
    parameterAttribute: 'nbrJoursVerifComplElib' | 'nbrJoursVerifComplCyc'
}

export const NumberParameter: React.FC<Props> = ({marqueId, collectionId, label, parameterAttribute}) => {

    const defaultParameter = {
        marque: marqueId,
        collection: collectionId ?? ''
    } as ParamsMarqueCollection
    const dispatch = useAppDispatch();

    const parameter = useSelector(({parametrage}: State) => parametrage.currentParamsMarqueCollection ?? defaultParameter)

    return (<Grid container spacing={2}>
            <Grid>
                {label}
            </Grid>
            <Grid>
                <TextField
                    type="number" InputProps={{
                    inputProps: {
                        max: 300, min: 0
                    }
                }}
                    style={{width: '75px'}}
                    value={parameter[parameterAttribute] ?? ''} onChange={(event) => {
                    const newParam = {
                        ...defaultParameter,
                        [parameterAttribute]: parseInt(event.target.value)
                    }
                    dispatch(updateMarqueEditorialeParameter(newParam))
                }
                }
                />
            </Grid>
            {(parameter && (parameter[parameterAttribute] || parameter[parameterAttribute] === 0)) ?
                <Grid>
                    <IconButton color="primary" aria-label="Effacer" component="span" size={"small"}
                                onClick={() => {
                                    dispatch(resetMarqueEditorialeParameter(
                                        {
                                            ...parameter,
                                            [parameterAttribute]: null
                                        }
                                    ))
                                }}>
                        <ClearIcon/>
                    </IconButton>
                </Grid> : <></>}

        </Grid>
    )
}
;
